export enum PROPOSAL_REGISTRATION_STATUS {
  PENDING = 'PENDING',
  AUTO_APPROVED = 'AUTO_APPROVED',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  ERROR = 'ERROR',
  CANCELED = 'CANCELED',
}
